export default "__VITE_ASSET__ab103648__"